const FileUtils = {

    /**
     * Creates a temporary download button to force a browser download.
     *
     * You might want to prefer `downloadJson` instead.
     *
     * @param fileName { string }
     * @param url { string }  A `http(s)://` like url, or a `data:…` blob.
     */
    download: function (fileName, urlOrBlob) {
        let url = urlOrBlob;

        // If it's a Blob, turn it into an object URL
        if (urlOrBlob instanceof Blob) {
            url = URL.createObjectURL(urlOrBlob);
        } else {
            typeof url === "string" && new URL(url); // validate
        }

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        if (urlOrBlob instanceof Blob) {
            URL.revokeObjectURL(url);
        }
    },

    /**
     * Creates a temporary download button to force a browser download.
     * @param fileName { string }
     * @param data { any }  A Json payload to download.
     */
    downloadJson: function (fileName, data) {
        return this.download(
            fileName,
            `data:application/json;charset=utf-8,${JSON.stringify(data, undefined, 2)}`
        );
    },

    /**
     * Creates a temporary download button to force a browser download.
     * @param fileName { string }
     * @param data { any }  A csv payload to download.
     */
    downloadCsv: function (fileName, data) {
        return this.download(fileName, new Blob([data], {type: "text/csv;charset=utf-8"}));
    }
};

export default FileUtils;
